import { Outlet } from 'react-router'
import { Header } from '@/components/commons/header'

function LuxeSubmissionsLayout() {
	return (
		<div className='flex h-dvh flex-col overflow-hidden'>
			<Header className='shrink-0' />
			<div className='flex flex-1 flex-col overflow-hidden'>
				<Outlet />
			</div>
		</div>
	)
}

export { LuxeSubmissionsLayout }
